<template>
  <table class="tb-col">
    <colgroup>
      <col style="width: 10%" />
      <col style="width: auto" />
      <col style="width: 23%" />
    </colgroup>
    <thead>
    <tr>
      <th>번호</th>
      <th>계약서명</th>
      <th class="last">등록일시</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(ctrtcFile, index) in ctrtcFiles"
        :key="'ctrtc_' + ctrtcFile.ctrtcId">
      <td>{{ index+1 }}</td>
      <td class="__left">
        <a href="javascript:;"
           @click="fileDwld_click(ctrtcFile)">{{ ctrtcFile.ctrtcSenm }}</a>
      </td>
      <td class="last">{{ $cmmn.date.getYmdhmsFormat(ctrtcFile.ctrtcWrtgDt) }}</td>
    </tr>
    <tr v-if="ctrtcFiles.length == 0">
      <td class="last" colspan="3">계약서가 존재하지 않습니다.</td>
    </tr>
    </tbody>
  </table>
</template>

<script setup>

import {ref, defineProps, onMounted} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$axios, $cmmn, $file} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  gdsCntrctSn: {
    type: Number,
    required: true
  }
});

const ctrtcFiles = ref([]);
const getCtrtcFilesByGdsCntrctSn = async () => {
  const {data} = await $axios.get('/api/svc/ctrtc-files/by-gds-cntrct-sn', {params: {gdsCntrctSn: props.gdsCntrctSn}});
  ctrtcFiles.value = data;
}

const fileDwld_click = async ({ncpObjectNm, orgnFlnm}) => {
  try {
    $loading.on();

    await $file.ncp.tcfl.dwld(ncpObjectNm, orgnFlnm);

  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

onMounted(async () => {
  try {
    $loading.on();

    await getCtrtcFilesByGdsCntrctSn();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
